<div class="ion-page" style="overflow-y: hidden !important ;">
  <ion-header>
    <ion-toolbar style="text-align: center;" color="secondary">
      <ion-title>
        {{user ? (user.FirstName + ' ' + user.LastName) : addUserByOwner ? ('Add user' | translate) : (addOwner ? ('Invite Owner' | translate) : ('Invite New External User' | translate))}}
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content color="secondary">
    <form [formGroup]="userForm" style="padding: 1.5em;">
      <br>
        <ion-item color="secondary">
          <ion-label position="stacked" [class.required]="userForm.get('FirstName')?.hasError('required')">
            {{ 'First name' | translate }}
          </ion-label>
          <ion-input type="text" formControlName="FirstName"></ion-input>
        </ion-item>
        <ion-item color="secondary" lines="none">
          @if (userForm.get('FirstName')?.errors && userFormSubmitted) {
            @if (userForm.get('FirstName')?.hasError('required')) {
              <ion-text color="warning">{{ 'Mandatory field' | translate }}</ion-text>
            }
          }
        </ion-item>

        <ion-item color="secondary">
          <ion-label position="stacked" [class.required]="userForm.get('LastName')?.hasError('required')">
            {{ 'Last name' | translate }}
          </ion-label>
          <ion-input type="text" formControlName="LastName"></ion-input>
        </ion-item>
        <ion-item color="secondary" lines="none">
          @if (userForm.get('LastName')?.errors && userFormSubmitted) {
            @if (userForm.get('LastName')?.hasError('required')) {
              <ion-text color="warning">{{ 'Mandatory field' | translate }}</ion-text>
            }
          }
        </ion-item>

        <ion-item color="secondary">
          <ion-label position="stacked" [class.required]="userForm.get('Email')?.hasError('required')">
            {{ 'E-mail address' | translate }}
          </ion-label>
          <ion-input type="text" formControlName="Email"></ion-input>
        </ion-item>
        <ion-item color="secondary" lines="none">
          @if (userForm.get('Email')?.errors && userFormSubmitted) {
            @if (userForm.get('Email')?.hasError('required')) {
              <ion-text color="warning">{{ 'Mandatory field' | translate }}</ion-text>
            }
          }
        </ion-item>

        <br>
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-button color="tertiary" expand="block" (click)="onBack()">{{ 'Cancel' | translate }}</ion-button>
              </ion-col>
              <ion-col>
                <ion-button color="medium" expand="block" (click)="saveUser()" type="submit">
                  @if (addUserByOwner) {
                    <ion-icon name="add"></ion-icon>
                    }&nbsp;
                    {{user ? ('Edit' | translate) : (addUserByOwner ? ('Add' | translate) : ('Invite' | translate))}}
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
          </form>
        </ion-content>
      </div>
